import { render, staticRenderFns } from "./SocialReportingFilters.vue?vue&type=template&id=9bffb2be&scoped=true&"
import script from "./SocialReportingFilters.vue?vue&type=script&lang=js&"
export * from "./SocialReportingFilters.vue?vue&type=script&lang=js&"
import style0 from "./SocialReportingFilters.vue?vue&type=style&index=0&id=9bffb2be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bffb2be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VRow})
